import axios from "axios";
import firebase from "firebase/app";
import "firebase/auth";
import { ENDPOINTS } from "../shared/constants/FormConstants";
import "../plugins/firebase";

function getValidatedUser(): any {
  return new Promise((resolve, reject) => {
    const unsubscribe = firebase.auth().onAuthStateChanged(user => {
      unsubscribe();
      resolve(user);
    }, reject);
  });
}

axios.interceptors.request.use(async request => {
  const user = await getValidatedUser();

  if (user) {
    const token = await user.getIdToken(true);
    localStorage.setItem("TOKEN", token);
  }

  if (request.url === ENDPOINTS.COUNTRY) return request;

  request.headers = {
    Authorization: localStorage.getItem("TOKEN"),
    "Content-Type": "application/json"
  };

  return request;
});
